<template>
  <div class="nt-videos-carousel nt-videos-carousel__swiper-container">
    <div class="swiper-wrapper">
      <slot name="item"></slot>
    </div>    
    <div v-show="showArrows" class="swiper-button-prev button-nav button-nav--prev">
      <svg><use xlink:href="#chevron-left"/></svg>
    </div>
    <div v-show="showArrows" class="swiper-button-next button-nav button-nav--next">
      <svg><use xlink:href="#chevron-right"/></svg>
    </div>
  </div>
</template>

<script>
import Swiper from 'swiper'
import _ from 'lodash'

export default {
  name: 'NtVideosCarousel',
  data() {
    return {
      swiper: null,
      showArrows: true
    }
  },
  mounted() {
    this.swiper = new Swiper('.nt-videos-carousel__swiper-container', {
      slidesPerView: 3,
      initialSlide: 1,
      spaceBetween: 0,
      centeredSlides: true,
      slideToClickedSlide: true,
      // breakpointsInverse: true,
      breakpoints: {
        // when window width is <= 920px
        920: {
          slidesPerView: 2
        }
      },
      navigation: {
        nextEl: '.button-nav--next',
        prevEl: '.button-nav--prev',
      }
    })
    this.swiper.on('slideChangeTransitionEnd', this.onChange)
    window.addEventListener('resize', this.onResize)
  },
  methods: {
    onResize() {
      this.swiper.virtual.update()
    },
    onChange() {
      const videos = _.filter(this.$children, item => item.$el.className === 'vt-video-container')
      this.$root.$emit('changeVideo', {
        id: videos[this.swiper.previousIndex].$children[0].id,
        command: 'stop'
      })
    }
  }
}
</script>
